import { render } from "./WalletCashTotalsCard.vue?vue&type=template&id=ba7677a6&scoped=true"
import script from "./WalletCashTotalsCard.vue?vue&type=script&lang=js"
export * from "./WalletCashTotalsCard.vue?vue&type=script&lang=js"

import "./WalletCashTotalsCard.vue?vue&type=style&index=0&id=ba7677a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba7677a6"]])

export default __exports__